import React from "react";
import '../styles/projectspage.css'
import placeholder from "../assets/images/placeholder.png"
import "../assets/common/fonts.css"

const ProjectsPage = () => {
  return (
    <div className="main-projects">
      <div className="projects-title">
        <h1>Nossos Modalidades e Serviços</h1>    
      </div>
       
        <ul class="projects-list">
          <li class="project-item">
            <img src= {placeholder} alt="Estúdio de Televisão"/>
            <div className="column-texts">
              <h1>PROJETO 1</h1>         
              <a href="/projects-estúdio">SAIBA MAIS</a>
            </div>
           
          </li>
          <li class="project-item">
            <img src={placeholder} alt="Rádios"/>
            <div className="column-texts">
              <h1>PROJETO 2</h1>
              <a href="/projects-rádios">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Aeroporto de Rio Galeão"/>
            <div className="column-texts">
              <h1>PROJETO 3</h1>
              <a href="/projects-aeroporto">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Shooping Ibirapuera"/>
            <div className="column-texts">
              <h1>PROJETO 4</h1>
              <a href="/projects-ibirapuera">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Banco Central"/>
            <div className="column-texts">
              <h1>PROJETO 5</h1>
              <a href="/projects-bancocentral">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Provedores de Internet"/>
            <div className="column-texts">
              <h1>PROJETO 6</h1>
              <a href="/projects-provedores">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Usinas"/>
            <div className="column-texts">
              <h1>PROJETO 7</h1>
              <a href="/projects-usinas">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Mineração"/>
            <div className="column-texts">
              <h1>PROJETO 8</h1>
              <a href="/projects-mineracao">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Plataformas"/>
            <div className="column-texts">
              <h1>PROJETO 9</h1>
              <a href="/projects-plataformas">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Allians Parque"/>
            <div className="column-texts">
              <h1>PROJETO 10</h1>
              <a href="/projects-allianz">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Transolímpica"/>
            <div className="column-texts">
              <h1>PROJETO 11</h1>
              <a href="/projects-transolimpica">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Velódromo"/>
            <div className="column-texts">
              <h1>PROJETO 12</h1>
              <a href="/projects-velodromo">SAIBA MAIS</a>
            </div>
          </li>

          <li class="project-item">
            <img src={placeholder} alt="Novo Maracanã"/>
            <div className="column-texts">
              <h1>PROJETO 13</h1>
              <a href="/projects-maracana">SAIBA MAIS</a>
            </div>
          </li>

       </ul>
    </div>
  );
};

export default ProjectsPage;
